import React, { Component } from "react";
import { Link } from 'react-router-dom'
import { inject, observer } from "mobx-react";
import LoadingPageOverlay from "../../../components/LoadingPageOverlay";
import ContractSelector from "../../../components/contractSelector";
import withRouter from "../../../components/withRouter";
import { OfficeWorkingHours } from "./components/OfficeWorkingHours";
import t from "../../../service/translate.service";
import { Alert } from "antd";
import { Booking } from "./components/Booking";
import { extendObservable } from "mobx";
import { find } from "lodash";
import User from '../../../store/user.store'
import NoContent from "../../../components/NoContent";
import { ContractsImage } from "../../../components/icons";
import historyService from '../../../service/history.service'
import { appFeatureEnabled } from "../../../service/appFeatures.service";

class ServicePointsPage extends Component {
  constructor(props) {
    super(props);
    this.store = this.props.consultationStore;
    this.contractStore = this.store.contractStore;
    this.navigate = this.props.navigate;
    extendObservable(this, {
      hasActiveContracts: false
    })
  }

 componentDidMount() {
  const filteredContracts = User?.user?.contracts?.filter((contract) => appFeatureEnabled('consultationsBookingEnabled', [contract]))
  const hasActiveContracts = Boolean(filteredContracts?.length);
  this.hasActiveContracts = hasActiveContracts

  if(hasActiveContracts) {
    this.contractStore.selectedContract = filteredContracts[0]
    this.store.getAll();
    this.store.getPropertyManagers();
  }
 }

  cancelAppointment = async (contractNumber, eventId) => {
    try {
        this.store.error = null
        this.store.loading = true
        await this.store.cancelEvent(contractNumber, eventId)
        this.store.isAppointmentRequested = 'not_requested'
        this.store.loading = false
    } catch (err) {
        this.store.loading = false
        this.store.error = t['ERROR']
    }
  }

  render() {
    if(!this.hasActiveContracts){
      return (
        <div>
          <div className="text-center">
            <Link
              to="/contracts/add-contract"
              className="button primary"
              style={{ marginBottom: "30px" }}
              onClick={() => historyService.push("/contracts/add-contract")}
              aria-label={t.ADD_A_CONTRACT_BUTTON}
            >
              {t.ADD_A_CONTRACT_BUTTON}
            </Link>
          </div>
          <NoContent message={t.NO_CONTRACTS} image={ContractsImage} />
        </div>
      )
    }
    return (
      <div>
        {this.store.loading && <LoadingPageOverlay aria-live="polite" />}
        <ContractSelector
          page="consultations"
          required={true}
          getConsultations={() => {
            this.store.success = false;
            this.store.getAll();
            this.store.getPropertyManagers();
          }}
          aria-label={t.SELECT_CONTRACT}
        />
        <div style={{ marginTop: 50 }}>
          {this.store.error && (
            <div style={{ marginBottom: 15 }} role="alert" aria-live="assertive">
              <Alert message={this?.store?.error || t["ERROR"]} type="error" aria-live="assertive" role='alert' />
            </div>
          )}
          {this.store.consultations.length > 0 ? (
            <OfficeWorkingHours offices={this.store.consultations} />
          ) : (
            <div className="description">
              {t["CONSULTATIONS_NO_OFFICE_1"]}{" "}
              <a href={`+493034655777`} aria-label={t["CONSULTATIONS_NO_OFFICE_2"]}>
                {t["CONSULTATIONS_NO_OFFICE_2"]}
              </a>
            </div>
          )}
        </div>
        {this.store.consultations.length > 0 && this.store.calendarId && appFeatureEnabled("consultationsBookingEnabled", User.user?.contracts) && (
          <Booking
            navigate={this.navigate}
            cancelEvent={this.cancelAppointment}
            contractStore={this.contractStore}
            store={this.store}
            isAppointmentRequested={this.store.isAppointmentRequested}
            aria-label={t.BOOK_APPOINTMENT}
          />
        )}
        <div style={{ marginTop: "50px" }}>
          <p style={{ color: "#a0a7aa" }} aria-describedby="consultation-disclaimer">
            {t.CONSULTATIONS_PAGE_DISCLAIMER}
          </p>
        </div>
      </div>
    );
  }
}

export default inject(
  "consultationStore",
  "contractStore",
)(withRouter(observer(ServicePointsPage)));
